import { useParams } from "react-router-dom";

import useUserName from "~/hooks/useUserName";
import { SheetBuilderApp } from "~/tools/js";

export default function Builder() {
  const { characterId } = useParams();
  const username = useUserName();

  return (
    <SheetBuilderApp
      characterId={parseInt(String(characterId), 10) || null}
      readOnly={!username}
    />
  );
}
